import {LavoratoreBase} from "@commons/mapping/LavoratoreBase";
import {PresenzeCausaleWFBase} from "./PresenzeCausaleWF";
import {DateTime} from "luxon";

export interface DashboardWFRecord extends LavoratoreBase {
    denominazione: string,
    numGiorniPeriodo: number,
    details: Detail[],
}

export interface DashboardWFRootDetails {
    count0: number, // Numero di richieste in attesa
    count1: number, // Numero di richieste in valutazione
    count2: number, // Numero di richieste accettate
    count3: number, // Numero di richieste rifiutate
    count4Export: number,
    countAnnullate: number, // Numero di richieste annullate
}

export interface Detail extends PresenzeCausaleWFBase {
    hhWeekMedie: number,
    festivo: boolean,
    anomaliaPresenze: number,
    hhPreviste: number,
    tipoOreGiustificativo: 'M' | 'E',
    quantitaGiustificativo: number,

    //idAziendaTabelle: number | null, NON PIU' NECESSARI, con l'ultima implementazione le informazioni sono reperite a monte dal front-end in base all'azienda corrente
    //idTipoTabella: number | null,
    //codTabella: string | null,
}

export class Detail {
    static isWeekend = (giornoDt: Date) => {
        const giorno = DateTime.fromJSDate(giornoDt).startOf('day');
        const saturday = giorno.weekday === 6; // 1 is Monday and 7 is Sunday
        const sunday = giorno.weekday === 7;
        const weekend = saturday || sunday;
        return {weekend, saturday, sunday};
    }
    static isAWF = (detail: Detail) => detail.wf;
    static isGiuMancante = (detail: Detail) => !detail.wf && detail.tipoOreGiustificativo==='M';
    static isGiuEccedente = (detail: Detail) => !detail.wf && detail.tipoOreGiustificativo==='E';
    static isAnnullata = (detail: Detail) => detail.wf && detail.wf.annullata;
}